document.documentElement.classList.remove('no-js');

(function () {
  function initDrawer(root) {
    var el = root.querySelector('[data-drawer]');
    var openBtn = root.querySelector('[data-drawer-open]');
    if (!el || !openBtn) return;

    function open() {
      el.hidden = false;
      requestAnimationFrame(function () {
        el.classList.add('is-open');
      });
      document.body.classList.add('is-locked');
      openBtn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      el.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () {
        el.hidden = true;
      }, 280);
    }

    openBtn.addEventListener('click', open);
    el.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !el.hidden) close();
    });
  }

  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var isAuto = root.hasAttribute('data-carousel-auto');
    var originals = Array.prototype.slice.call(track.children);
    var pausedUntil = 0;
    var looping = false;

    function step() {
      var item = track.firstElementChild;
      if (!item) return Math.max(1, track.clientWidth);
      var cs = getComputedStyle(track);
      var gap = parseFloat(cs.columnGap || cs.gap || 0) || 0;
      return item.getBoundingClientRect().width + gap;
    }
    function loopWidth() {
      if (!looping) return 0;
      var mid = track.children[originals.length];
      var first = track.children[0];
      if (!mid || !first) return 0;
      return mid.getBoundingClientRect().left - first.getBoundingClientRect().left;
    }
    function wrap(value) {
      var loopAt = loopWidth();
      if (loopAt <= 0) {
        var max = Math.max(0, track.scrollWidth - track.clientWidth);
        return Math.max(0, Math.min(max, value));
      }
      var nextLeft = value;
      while (nextLeft < 0) nextLeft += loopAt;
      while (nextLeft >= loopAt) nextLeft -= loopAt;
      return nextLeft;
    }
    function pause(ms) {
      pausedUntil = performance.now() + (ms || 2400);
    }
    function go(dir) {
      pause(2600);
      track.scrollLeft = wrap(track.scrollLeft + dir * step());
    }
    function sync() {
      if (isAuto) {
        if (prev) prev.disabled = false;
        if (next) next.disabled = false;
        return;
      }
      var max = track.scrollWidth - track.clientWidth - 1;
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) {
      prev.addEventListener('click', function (e) {
        e.preventDefault();
        go(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function (e) {
        e.preventDefault();
        go(1);
      });
    }
    track.addEventListener('pointerdown', function () { pause(2600); }, { passive: true });
    track.addEventListener('touchstart', function () { pause(2600); }, { passive: true });
    track.addEventListener('scroll', function () {
      requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    if (!isAuto) return;
    if (originals.length < 2) return;

    originals.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });
    looping = true;

    var last = performance.now();
    function tick(now) {
      var dt = Math.min(48, now - last);
      last = now;
      if (now >= pausedUntil) {
        var loopAt = loopWidth();
        if (loopAt > 0) {
          track.scrollLeft = wrap(track.scrollLeft + (0.048 * dt));
        }
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function initGalleryAutoplay(root) {
    var track = root.querySelector('[data-carousel-track]') || root;
    var videos = root.querySelectorAll('video');
    if (!videos.length) return;

    function prepare(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.volume = 0;
      video.loop = true;
      video.controls = false;
      video.playsInline = true;
      video.preload = 'auto';
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.removeAttribute('controls');
    }

    function tryPlay(video) {
      prepare(video);
      if (!video.paused) return;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) playPromise.catch(function () {});
    }

    function isVisible(video) {
      var rootBox = track.getBoundingClientRect();
      var box = video.getBoundingClientRect();
      return box.right > rootBox.left - 80 && box.left < rootBox.right + 80 && box.bottom > 0 && box.top < window.innerHeight;
    }

    function sync() {
      videos.forEach(function (video) {
        if (isVisible(video)) tryPlay(video);
        else video.pause();
      });
    }

    videos.forEach(function (video) {
      prepare(video);
      if (video.readyState === 0) {
        try { video.load(); } catch (err) {}
      }
      video.addEventListener('canplay', function () {
        if (isVisible(video)) tryPlay(video);
      });
    });

    sync();
    track.addEventListener('scroll', function () {
      requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('scroll', function () {
      requestAnimationFrame(sync);
    }, { passive: true });
    window.addEventListener('resize', sync);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sync();
    });
    window.addEventListener('pageshow', sync);
    document.addEventListener('touchstart', sync, { passive: true });
    document.addEventListener('pointerdown', sync, { passive: true });
    document.addEventListener('click', sync);
    window.setInterval(function () {
      videos.forEach(function (video) {
        if (isVisible(video) && video.paused) tryPlay(video);
      });
    }, 1200);
  }

  function hexToRgb(hex) {
    var n = hex.replace('#', '');
    if (n.length === 3) n = n[0] + n[0] + n[1] + n[1] + n[2] + n[2];
    return [parseInt(n.slice(0, 2), 16), parseInt(n.slice(2, 4), 16), parseInt(n.slice(4, 6), 16)];
  }
  function mixHex(a, b, t) {
    var A = hexToRgb(a);
    var B = hexToRgb(b);
    var r = Math.round(A[0] + (B[0] - A[0]) * t);
    var g = Math.round(A[1] + (B[1] - A[1]) * t);
    var bl = Math.round(A[2] + (B[2] - A[2]) * t);
    return 'rgb(' + r + ',' + g + ',' + bl + ')';
  }
  function colorAlong(progress) {
    var stops = ['#5f6240', '#7b8e64', '#a67c52', '#6b3d2a', '#561d1a'];
    var scaled = progress * (stops.length - 1);
    var i = Math.min(stops.length - 2, Math.floor(scaled));
    return mixHex(stops[i], stops[i + 1], scaled - i);
  }

  function initSticky() {
    var header = document.querySelector('.site-header--sticky');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-stuck', window.scrollY > 10);
    }, { passive: true });
  }

  function initMarkColor() {
    var mark = document.querySelector('.philosophy .dojo-mark');
    if (!mark) return;
    function paint() {
      var rect = mark.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var center = rect.top + rect.height / 2;
      var p = 1 - center / vh;
      p = Math.max(0, Math.min(1, p));
      mark.style.setProperty('--dojo-mark-color', colorAlong(p));
    }
    window.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint);
    paint();
  }

  function initFacets(root) {
    var form = root.querySelector('[data-facets-form]');
    if (!form) return;
    form.querySelectorAll('input, select').forEach(function (el) {
      el.addEventListener('change', function () {
        form.submit();
      });
    });
  }

  function initQty(root) {
    root.querySelectorAll('[data-qty]').forEach(function (qty) {
      var input = qty.querySelector('[data-qty-input]');
      var down = qty.querySelector('[data-qty-down]');
      var up = qty.querySelector('[data-qty-up]');
      if (!input) return;
      function set(value) {
        var next = parseInt(value, 10);
        var min = parseInt(input.min, 10);
        if (isNaN(min)) min = 1;
        if (isNaN(next) || next < min) next = min;
        input.value = next;
      }
      if (down) down.addEventListener('click', function () {
        set((parseInt(input.value, 10) || 1) - 1);
      });
      if (up) up.addEventListener('click', function () {
        set((parseInt(input.value, 10) || 1) + 1);
      });
    });
  }

  function initProductMedia(root) {
    var page = root.querySelector('[data-product-page]');
    if (!page) return;
    var slides = page.querySelectorAll('.product-media__slide');
    var thumbs = page.querySelectorAll('.product-thumb');
    var main = page.querySelector('.product-media__main');

    function showSlide(id, updateThumbs) {
      var target = String(id);
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', String(slide.getAttribute('data-media-id')) === target);
      });
      if (updateThumbs) {
        thumbs.forEach(function (thumb) {
          thumb.classList.toggle('is-active', String(thumb.getAttribute('data-media-target')) === target);
        });
      }
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        showSlide(btn.getAttribute('data-media-target'), true);
      });
    });

    if (!main || slides.length < 2) return;
    main.classList.add('product-media__main--peek');
    slides.forEach(function (slide) {
      var img = slide.querySelector('img');
      if (!img) return;
      img.loading = 'eager';
      if (img.src) {
        var preload = new Image();
        preload.src = img.currentSrc || img.src;
      }
    });

    function peekTarget() {
      var active = page.querySelector('.product-media__slide.is-active');
      if (!active) return null;
      if (active.nextElementSibling && active.nextElementSibling.classList.contains('product-media__slide')) {
        return active.nextElementSibling;
      }
      return slides[0] === active ? null : slides[0];
    }

    function setPeek(on) {
      slides.forEach(function (slide) { slide.classList.remove('is-peek'); });
      main.classList.toggle('is-peeking', !!on);
      if (!on) return;
      var next = peekTarget();
      if (next) next.classList.add('is-peek');
    }

    main.addEventListener('pointerenter', function () { setPeek(true); });
    main.addEventListener('mouseenter', function () { setPeek(true); });
    main.addEventListener('pointerleave', function () { setPeek(false); });
    main.addEventListener('mouseleave', function () { setPeek(false); });
  }

  function initProductCardPeek(root) {
    root.querySelectorAll('.dojo-product-card__media--peek').forEach(function (media) {
      var next = media.querySelector('img.is-next');
      if (next && next.src) {
        var preload = new Image();
        preload.src = next.currentSrc || next.src;
      }
      media.addEventListener('pointerenter', function () { media.classList.add('is-peeking'); });
      media.addEventListener('mouseenter', function () { media.classList.add('is-peeking'); });
      media.addEventListener('pointerleave', function () { media.classList.remove('is-peeking'); });
      media.addEventListener('mouseleave', function () { media.classList.remove('is-peeking'); });
    });
  }

  function initWriteReview(root) {
    var modal = root.querySelector('[data-review-modal]') || document.querySelector('[data-review-modal]');
    var openers = root.querySelectorAll('[data-review-open]');
    if (!modal || !openers.length) return;
    var form = modal.querySelector('[data-review-form]');
    var errorEl = modal.querySelector('[data-review-error]');
    var successEl = modal.querySelector('[data-review-success]');
    var submitBtn = modal.querySelector('[data-review-submit]');
    var starRow = modal.querySelector('.dojo-review-modal__star-row');
    var productSelect = form && form.querySelector('[data-review-product]');
    var titleEl = modal.querySelector('[data-review-title]');
    var photoEl = modal.querySelector('[data-review-photo]');

    function syncSelectedProduct() {
      if (!form) return '';
      if (!productSelect) return form.getAttribute('data-product-id') || '';
      var option = productSelect.options[productSelect.selectedIndex];
      var productId = productSelect.value || '';
      form.setAttribute('data-product-id', productId);
      if (option && titleEl) titleEl.textContent = option.getAttribute('data-title') || option.textContent || '';
      if (photoEl) {
        var image = option ? option.getAttribute('data-image') : '';
        if (image) {
          photoEl.src = image;
          photoEl.alt = option.getAttribute('data-title') || '';
          photoEl.hidden = false;
        } else {
          photoEl.hidden = true;
        }
      }
      return productId;
    }

    function closeModal() {
      modal.hidden = true;
      document.body.classList.remove('is-review-open');
    }

    function openModal() {
      syncSelectedProduct();
      modal.hidden = false;
      document.body.classList.add('is-review-open');
      var first = modal.querySelector('[data-review-product], input[name="rating"], textarea[name="body"]');
      if (first) first.focus();
    }

    if (productSelect) {
      productSelect.addEventListener('change', syncSelectedProduct);
      syncSelectedProduct();
    }

    function paintStars(value, hoverValue) {
      if (!starRow) return;
      var fill = hoverValue || value || 0;
      starRow.querySelectorAll('label').forEach(function (label, index) {
        var starValue = index + 1;
        label.classList.toggle('is-on', starValue <= (value || 0));
        label.classList.toggle('is-hover', !!hoverValue && starValue <= hoverValue);
      });
    }

    function selectedRating() {
      var checked = form && form.querySelector('input[name="rating"]:checked');
      return checked ? parseInt(checked.value, 10) : 0;
    }

    if (starRow) {
      starRow.querySelectorAll('input[name="rating"]').forEach(function (input) {
        input.addEventListener('change', function () { paintStars(selectedRating()); });
      });
      starRow.querySelectorAll('label').forEach(function (label, index) {
        label.addEventListener('mouseenter', function () { paintStars(selectedRating(), index + 1); });
      });
      starRow.addEventListener('mouseleave', function () { paintStars(selectedRating()); });
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        openModal();
      });
    });
    modal.querySelectorAll('[data-review-close]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    if (!form) return;
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (successEl) successEl.hidden = true;
      var rating = selectedRating();
      var body = (form.querySelector('[name="body"]') || {}).value || '';
      var name = (form.querySelector('[name="name"]') || {}).value || '';
      var email = (form.querySelector('[name="email"]') || {}).value || '';
      var title = (form.querySelector('[name="title"]') || {}).value || '';
      if (!rating || !body.trim() || !name.trim() || !email.trim()) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'Please add a rating, review, name, and email.';
        }
        return;
      }
      var productId = syncSelectedProduct() || (form.getAttribute('data-product-id') || '');
      if (!productId) {
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = 'Please choose a product to review.';
        }
        return;
      }
      var params = (window.jdgm && typeof jdgm.shopParams === 'function') ? jdgm.shopParams() : {};
      var payload = Object.assign({}, params, {
        rating: rating,
        name: name.trim(),
        email: email.trim(),
        title: title.trim(),
        body: body.trim(),
        id: productId,
        platform: params.platform || 'shopify'
      });
      var data = new FormData();
      Object.keys(payload).forEach(function (key) {
        if (payload[key] != null && payload[key] !== '') data.append(key, payload[key]);
      });
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';
      }
      var url = (window.jdgm && jdgm.API_HOST ? jdgm.API_HOST : 'https://api.judge.me') + '/api/v1/reviews';
      function finish(ok, message) {
        if (ok) {
          form.hidden = true;
          if (successEl) successEl.hidden = false;
        } else if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent = message || 'Something went wrong. Please try again.';
        }
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Submit review';
        }
      }
      if (window.jdgm && jdgm.$ && jdgm.$.ajax) {
        jdgm.$.ajax({ url: url, method: 'POST', processData: false, contentType: false, data: data })
          .done(function () { finish(true); })
          .fail(function () { finish(false); });
        return;
      }
      fetch(url, { method: 'POST', body: data }).then(function (res) {
        if (!res.ok) throw new Error('submit failed');
        finish(true);
      }).catch(function () { finish(false); });
    });
  }

  function formatMoney(cents) {
    var value = (Number(cents) / 100).toFixed(2);
    return '$' + value;
  }

  function initVariants(root) {
    var formWrap = root.querySelector('[data-product-form]');
    if (!formWrap) return;
    var dataEl = formWrap.querySelector('[data-variant-data]');
    var idInput = formWrap.querySelector('[data-variant-id]');
    if (!dataEl || !idInput) return;
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      return;
    }
    var page = root.querySelector('[data-product-page]') || root;
    var priceEl = page.querySelector('[data-price]');
    var stockEl = page.querySelector('[data-stock]');
    var addBtn = formWrap.querySelector('[data-add-button]');

    function selectedOptions() {
      var opts = [];
      formWrap.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('[data-option-input]:checked');
        opts.push(checked ? checked.value : '');
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function (variant) {
        return (variant.options || []).every(function (option, index) {
          return option === opts[index];
        });
      });
    }

    function sync() {
      var variant = findVariant(selectedOptions());
      if (!variant) return;
      idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = '<span class="price"><span class="price__current">' + formatMoney(variant.price) + '</span></span>';
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        var label = addBtn.querySelector('[data-add-label]');
        if (label) label.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (stockEl) {
        stockEl.innerHTML = variant.available
          ? '<span class="product-stock__dot"></span> In stock'
          : '<span class="product-stock__dot is-out"></span> Sold out';
      }
      formWrap.querySelectorAll('[data-option-index]').forEach(function (fieldset) {
        var selected = fieldset.querySelector('[data-option-selected]');
        var checked = fieldset.querySelector('[data-option-input]:checked');
        if (selected && checked) selected.textContent = checked.value;
      });
      var media = variant.featured_media;
      if (media && media.id) {
        var thumb = page.querySelector('[data-media-target="' + media.id + '"]');
        if (thumb) thumb.click();
      }
    }

    formWrap.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', sync);
    });
  }

  function initSignupPopup() {
    var root = document.querySelector('[data-signup-popup]');
    if (!root) return;

    var storageKey = 'dojo-signup-popup-dojo5';
    var preview = root.getAttribute('data-preview') === 'true' || /[?&]signup=1(?:&|$)/.test(window.location.search);
    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) delay = 10000;
    var scrollAt = parseFloat(root.getAttribute('data-scroll'));
    if (isNaN(scrollAt)) scrollAt = 0.4;
    var formView = root.querySelector('[data-signup-form-view]');
    var successView = root.querySelector('[data-signup-success]');
    var form = root.querySelector('#SignupPopupForm');
    var errorEl = root.querySelector('[data-signup-error]');
    var submitBtn = root.querySelector('[data-signup-submit]');
    var copyBtn = root.querySelector('[data-signup-copy]');
    var dialog = root.querySelector('.signup-popup__dialog');
    var lastFocus = null;
    var openTimer = null;
    var opened = false;

    function storageGet() {
      try {
        return JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      } catch (err) {
        return null;
      }
    }
    function storageSet(state) {
      try {
        var until = state === 'dismissed' ? Date.now() + 7 * 24 * 60 * 60 * 1000 : 0;
        window.localStorage.setItem(storageKey, JSON.stringify({ state: state, until: until }));
      } catch (err) {}
    }
    function shouldSkip() {
      if (preview) return false;
      var saved = storageGet();
      if (!saved) return false;
      if (saved.state === 'subscribed') return true;
      if (saved.state === 'dismissed' && saved.until && saved.until > Date.now()) return true;
      return false;
    }
    function showSuccess() {
      if (formView) formView.hidden = true;
      if (successView) successView.hidden = false;
      storageSet('subscribed');
    }
    function open() {
      if (opened) return;
      opened = true;
      if (openTimer) window.clearTimeout(openTimer);
      window.removeEventListener('scroll', onScroll);
      lastFocus = document.activeElement;
      root.hidden = false;
      document.body.classList.add('is-signup-open');
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      var first = root.querySelector('#SignupPopupFirst');
      if (first && !coarse) first.focus();
    }
    function scrollRatio() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return 1;
      return (window.pageYOffset || doc.scrollTop) / scrollable;
    }
    function onScroll() {
      if (scrollRatio() >= scrollAt) open();
    }
    function close() {
      root.hidden = true;
      document.body.classList.remove('is-signup-open');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function dismiss() {
      var saved = storageGet();
      if (!saved || saved.state !== 'subscribed') storageSet('dismissed');
      close();
    }

    root.querySelectorAll('[data-signup-close]').forEach(function (btn) {
      btn.addEventListener('click', dismiss);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) dismiss();
    });
    if (dialog) {
      dialog.addEventListener('wheel', function (e) {
        window.scrollBy(e.deltaX, e.deltaY);
      }, { passive: true });
    }

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = (root.querySelector('[data-signup-code]') || {}).textContent || 'DOJO5';
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code.trim()).then(function () {
            copyBtn.textContent = 'Copied';
          }).catch(function () {
            copyBtn.textContent = 'Copied';
          });
        } else {
          copyBtn.textContent = 'Copied';
        }
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Joining…';
        }
        var body = new URLSearchParams(new FormData(form));
        fetch(form.getAttribute('action') || '/contact', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
          body: body.toString()
        }).then(function (res) {
          if (!res.ok) throw new Error('signup failed');
          showSuccess();
          if (dialog) dialog.focus();
        }).catch(function () {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = 'Something went wrong. Please try again.';
          }
        }).then(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Join the DOJO';
          }
        });
      });
    }

    if (shouldSkip()) return;
    if (preview) {
      openTimer = window.setTimeout(open, 400);
      return;
    }
    openTimer = window.setTimeout(open, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function hideOffPage(el) {
    if (!el || el.getAttribute('data-dojo-offpage') === '1') return;
    el.setAttribute('data-dojo-offpage', '1');
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('left', '-9999px', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('top', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
    el.style.setProperty('width', '0', 'important');
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
    el.style.setProperty('opacity', '0', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
  }

  function clipChatShadow(root) {
    if (!root || root.querySelector('style[data-dojo-chat-clip]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-dojo-chat-clip', '1');
    style.textContent = [
      '.activator-nudge > :not(.activator){',
      'position:fixed!important;left:-9999px!important;right:auto!important;top:auto!important;bottom:auto!important;',
      'width:0!important;height:0!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;',
      '}',
      'shopify-agent-runtime,.agent-shell,.agent-shell__runtime{',
      'position:fixed!important;left:-9999px!important;width:0!important;height:0!important;overflow:hidden!important;opacity:0!important;pointer-events:none!important;',
      '}'
    ].join('');
    root.appendChild(style);
  }

  function initChatOverlap() {
    function sweep() {
      document.querySelectorAll('shopify-agent, shopify-agent-runtime').forEach(hideOffPage);
      document.querySelectorAll('iframe').forEach(function (frame) {
        var src = frame.getAttribute('src') || '';
        if (/agent-iframe|shopify-agent/i.test(src)) hideOffPage(frame);
      });
      document.querySelectorAll('shopify-chat').forEach(function (chat) {
        if (chat.shadowRoot) clipChatShadow(chat.shadowRoot);
      });
    }
    sweep();
    var observer = new MutationObserver(sweep);
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  function initArticleVideos(root) {
    var hosts = root.querySelectorAll('.dojo-article-video, .journal-article video, .journal-article__body video');
    if (!hosts.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var videos = [];
    hosts.forEach(function (el) {
      var video = el;
      if (el.tagName !== 'VIDEO') {
        if (el.querySelector('video')) {
          video = el.querySelector('video');
        } else {
          video = document.createElement('video');
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.setAttribute('muted', '');
          video.muted = true;
          video.defaultMuted = true;
          video.loop = true;
          video.controls = true;
          video.preload = 'metadata';
          var src = el.getAttribute('data-src');
          var poster = el.getAttribute('data-poster');
          if (src) video.src = src;
          if (poster) video.poster = poster;
          el.appendChild(video);
        }
      }
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      videos.push(video);
    });

    if (!videos.length) return;
    if (!('IntersectionObserver' in window)) {
      videos.forEach(function (video) {
        var play = video.play();
        if (play && play.catch) play.catch(function () {});
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.4, 0.75] });

    videos.forEach(function (video) { observer.observe(video); });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-header]').forEach(initDrawer);
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
    document.querySelectorAll('.editorial-gallery').forEach(initGalleryAutoplay);
    initSticky();
    initMarkColor();
    initQty(document);
    initProductMedia(document);
    initProductCardPeek(document);
    initWriteReview(document);
    initVariants(document);
    initFacets(document);
    initSignupPopup();
    initChatOverlap();
    initArticleVideos(document);
  });
})();
